import request from "@/api/request";

// 管理员 数据管理
export const list = (data) => {
  return request({
    url: "/project/query",
    method: "POST",
    params: data,
  });
};
// 管理员 根据申报编号查询信息
export const search = (data) => {
  return request({
    url: "/auditing-advice/getAuditingItemInfo",
    method: "GET",
    params: data,
  });
};
export const delProjectById = (data) => {
  return request({
    url: "/project/remove",
    method: "POST",
    params: data,
  });
};
// 管理员 根据状态获取用户上传和未上传项目数量
export const getUploadCount = (data) => {
  return request({
    url: "/auditing-advice/getUploadCount",
    method: "GET",
    params: data,
  });
};
export const updateUser = (data) => {
  return request({
    url: "/user/applyUser",
    method: "POST",
    params: data,
  });
};
// 管理员 查看管理员信息
export const expertsQuery = (data) => {
  return request({
    url: "/experts-user/query/id",
    method: "GET",
    params: data,
  });
};
export const exportWorldFile = (data) =>{
  return request({
    url: "/project/createBook",
    method: "GET",
    params: data,
    responseType: "blob",
  });
}
// 管理员 根据id查询审核项目
export const auditingAdviceId = (data) => {
  return request({
    url: "/auditing-advice/query/id",
    method: "POST",
    params: data,
  });
};
// 管理员 主持人信息
export const applyInfo = (data) => {
  return request({
    url: "/apply-user/query",
    method: "POST",
    params: data,
  });
};
// 管理员 获取评审专家已审核和未审核数量
export const getAuditingCount = (data) => {
  return request({
    url: "/auditing-advice/getAuditingCount",
    method: "GET",
    params: data,
  });
};
// 管理员 统计评审专家个数
export const experts = (data) => {
  return request({
    url: "/experts-user/query",
    method: "POST",
    params: data,
  });
};
// 管理员 是否打回评审专家重新审核项目
export const doAuditing = (data) => {
  return request({
    url: "/auditing-advice/doAuditing",
    method: "POST",
    params: data,
  });
};
// 管理员 分配项目给评审专家
export const distribution = (data) => {
  return request({
    url: "/auditing-advice/distribution",
    method: "POST",
    params: data,
  });
};
export const cancelDistribution = (data) => {
  return request({
    url: "/auditing-advice/removeDistribution",
    method: "POST",
    params: data,
  });
};
// 管理员 根据状态获取项目详情
export const getAuditingItem = (data) => {
  return request({
    url: "/auditing-advice/getAuditingItem",
    method: "GET",
    params: data,
  });
};

// 管理员 查看信息 基础数据
export const queryBaseData = (data) => {
  return request({
    url: "/project/queryBaseData",
    method: "GET",
    params: data,
  });
};
// 管理员 查看信息 课题论证
export const queryProjectDemonstration = (data) => {
  return request({
    url: "/project/queryProjectDemonstration",
    method: "GET",
    params: data,
  });
};
// 管理员 查看信息 单位意见
export const queryCommendedAdvice = (data) => {
  return request({
    url: "/project/queryCommendedAdvice",
    method: "GET",
    params: data,
  });
};
// 管理员 查看信息 推荐人意见
export const queryRefereeAdvice = (data) => {
  return request({
    url: "/project/queryRefereeAdvice",
    method: "GET",
    params: data,
  });
};
// 管理员 查看信息 预期成果
export const queryResearchResult = (data) => {
  return request({
    url: "/project/queryResearchResult",
    method: "GET",
    params: data,
  });
};
// 管理员 查看信息 专家评审
export const queryCenterReview = (data) => {
  return request({
    url: "/project/queryCenterReview",
    method: "GET",
    params: data,
  });
};
// 管理员 查看信息 专家评审
export const queryByAuditingUserInfo = (data) => {
  return request({
    url: "/auditing-advice/queryByAuditingUserInfo",
    method: "GET",
    params: data,
  });
};
// 查看所有周期
export const queryPeriod = (data) => {
  return request({
    url: "/apply-period/query",
    method: "GET",
    params: data,
  });
};
// 添加周期
export const addPeriod = (data) => {
  return request({
    url: "/apply-period/doSubmit",
    method: "POST",
    data: data,
  });
};
// 根据项目id查看审核项目属于哪个周期之下的项目
export const getByProjectId = (data) => {
  return request({
    url: "/auditing-advice/getByProjectId",
    method: "GET",
    params: data,
  });
};
// 根据项目id查看项目属于哪个周期之下的项目
export const queryByPeriodId = (data) => {
  return request({
    url: "/project/queryByPeriodId",
    method: "GET",
    params: data,
  });
};
export const queryUserListById = (data) => {
  return request({
    url: "/project/queryByApplyId",
    method: "GET",
    params: data,
  });
};
// 根据项目id查看项目属于哪个周期之下的项目
export const removePeriodId = (data) => {
  return request({
    url: "/apply-period/remove",
    method: "POST",
    params: data,
  });
};
// 根据项目id查看项目周期
export const queryPeriodId = (data) => {
  return request({
    url: "/apply-period/query/id",
    method: "POST",
    params: data,
  });
};

export const exportExcelFile = (data) => {
  return request({
    url: "/project/exportInStorage",
    method: "GET",
    params: data,
    responseType: "blob",
  });
};
export const exportAll = (data) => {
  return request({
    url: "/project/export",
    method: "GET",
    params: data,
    responseType: "blob",
  });
};
export const queryAllPeriod = () => {
  return request({
    url: "/apply-period/listAll",
    method: "POST",
  });
};
export const delApplyUser = (data) => {
  return request({
    url: "/apply-user/remove",
    method: "POST",
    params: data,
  });
};
export const delApplyExperts = (data) => {
  return request({
    url: "/experts-user/remove",
    method: "POST",
    params: data,
  });
};
export const exportUserExcelFile = () => {
    return request({
        url: "/experts-user/export",
        method: "GET",
        responseType: "blob",
      });
}
export const okPass = (data) => {
  return request({
      url: "/auditing-advice/doFirstAuditing",
      method: "POST",
      params:data
    });
}

export const exportAdviceExcelFile = (data) =>{
  return request({
    url: "/auditing-advice/export",
    method: "GET",
    params: data,
    responseType: "blob",
  });
}

export const secondaryAdmin = (data) => {
  return request({
    url: "/secondary-admin/query",
    method: "POST",
    params: data,
  });
};

export const delSecondaryAdmin = (data) => {
  return request({
    url: "/secondary-admin/remove",
    method: "POST",
    params: data,
  });
};

export const secondaryAdminSave = (data) => {
  return request({
    url: "/secondary-admin/doSubmit",
    method: "POST",
    params: data,
  });
};
